import { Provider } from '@angular/core';
import { ORGANIZATION_REPOSITORY } from '../../../../../shared/domain/tokens/organization.token';
import { OrganizationRepositoryAdapter } from '../adapters/organization-repository.adapter';

export const ORGANIZATION_PROVIDERS: Provider[] = [
  {
    provide: ORGANIZATION_REPOSITORY,
    useClass: OrganizationRepositoryAdapter
  },

];
